import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import { hooks } from '../../../config/api';
export var useFindPrimaryPlans = function useFindPrimaryPlans(selectedPlan) {
  var _context, _response$data$data, _response$data;
  var _hooks$useFind = hooks.useFind('plan', {
      id: _mapInstanceProperty(_context = selectedPlan.required_health_plans).call(_context, function (el) {
        return el.id;
      }).join(),
      state: 'active',
      'plan_type': 'medicaid'
    }, {
      queryConfig: {
        placeholderData: undefined
      }
    }),
    response = _hooks$useFind.data,
    isLoading = _hooks$useFind.isLoading;
  var primaryPlans = (_response$data$data = response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data) !== null && _response$data$data !== void 0 ? _response$data$data : [];
  return {
    primaryPlans: primaryPlans,
    isLoading: isLoading
  };
};
//# sourceMappingURL=useFindPrimaryPlans.js.map